module.exports = __webpack_public_path__ + "img/videoInstructionIcon.0420b876.svg";